/* CNOIR Concierge: fold the made-to-measure form (agbada, kaftans) into one row. 2026-10-18 */
(function () {
  var root = document.querySelector('[data-cnoir-concierge]');
  if (!root) return;
  var section = root.closest('section, .shopify-section') || document;
  // 6. Made-to-measure pieces (agbada, kaftans): measurements fold into one row. It stays inside the product form,
  //    so the order still carries every field; nothing is cut until measurements arrive.
  section.querySelectorAll('.cnoir-mtm').forEach(function (m) {
    if (m.closest('.cnoir-cc-mtm')) return;
    var d = document.createElement('details'); d.className = 'cnoir-cc-mtm';
    d.innerHTML = '<summary><span><b>Your measurements</b><small>Optional: add them now, or we email you a simple guide after you order. Nothing is cut until we have them.</small></span></summary>';
    m.parentNode.insertBefore(d, m); d.appendChild(m);
  });
})();
